import React from 'react'
import { Navigate } from 'react-router-dom'
import authService from '../../services/authService'

export default function ProtectedRoute({ children }) {
  const token = authService.getAccessJWT()

  if (token === 'no_token') {
    return <Navigate to="/dashboard" replace />
  }

  if (authService.checkTokenExpiry()) {
    authService.removeToken()
    return <Navigate to="/logout" replace />
  }

  return children
}
